import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import api from "@/lib/api";
import { getConsent } from "@/components/CookieConsent";

// Fire-and-forget anonymous page-visit tracking on every route change.
// Respects GDPR consent: only tracks when the user accepted analytics cookies.
export const VisitTracker = () => {
  const location = useLocation();
  useEffect(() => {
    if (getConsent() !== "accepted") return;
    api
      .post("/track/visit", { path: location.pathname, referrer: document.referrer || "" })
      .catch(() => {});
  }, [location.pathname]);
  return null;
};
